import { AnyAction } from 'redux'
import {
  EXAMINATION_TYPE_CREATE_FAIL,
  EXAMINATION_TYPE_CREATE_REQUEST,
  EXAMINATION_TYPE_CREATE_RESET,
  EXAMINATION_TYPE_CREATE_SUCCESS,
  EXAMINATION_TYPE_DELETE_FAIL,
  EXAMINATION_TYPE_DELETE_REQUEST,
  EXAMINATION_TYPE_DELETE_RESET,
  EXAMINATION_TYPE_DELETE_SUCCESS,
  EXAMINATION_TYPE_EDIT_FAIL,
  EXAMINATION_TYPE_EDIT_REQUEST,
  EXAMINATION_TYPE_EDIT_RESET,
  EXAMINATION_TYPE_EDIT_SUCCESS,
  EXAMINATION_TYPE_EXAMINATION_SELECTION_SEARCH_GET_ALL_FAIL,
  EXAMINATION_TYPE_EXAMINATION_SELECTION_SEARCH_GET_ALL_REQUEST,
  EXAMINATION_TYPE_EXAMINATION_SELECTION_SEARCH_GET_ALL_RESET,
  EXAMINATION_TYPE_EXAMINATION_SELECTION_SEARCH_GET_ALL_SUCCESS,
  EXAMINATION_TYPE_GET_ALL_FAIL,
  EXAMINATION_TYPE_GET_ALL_REQUEST,
  EXAMINATION_TYPE_GET_ALL_SUCCESS,
  EXAMINATION_TYPE_GET_ONE_FAIL,
  EXAMINATION_TYPE_GET_ONE_REQUEST,
  EXAMINATION_TYPE_GET_ONE_RESET,
  EXAMINATION_TYPE_GET_ONE_SUCCESS
} from 'src/redux/constants/examinationTypeConstants'
import i18n from 'src/services/language.service'

const errorMessage = i18n.t('ERROR_MESSAGES.DEFAULT')
const examinationTypeCreateReducer = (state = {}, action: AnyAction) => {
  let error = ''
  switch (action.type) {
    case EXAMINATION_TYPE_CREATE_REQUEST:
      return { loading: true }
    case EXAMINATION_TYPE_CREATE_SUCCESS:
      return { loading: false, success: true }
    case EXAMINATION_TYPE_CREATE_FAIL:
      error = errorMessage
      return { loading: false, error }
    case EXAMINATION_TYPE_CREATE_RESET:
      return {}
    default:
      return state
  }
}

const examinationTypeDeleteReducer = (state = {}, action: AnyAction) => {
  let error = ''
  switch (action.type) {
    case EXAMINATION_TYPE_DELETE_REQUEST:
      return { loading: true }
    case EXAMINATION_TYPE_DELETE_SUCCESS:
      return { loading: false, success: true }
    case EXAMINATION_TYPE_DELETE_FAIL:
      switch (action.payload.message) {
        case 'EXAMINATION_TYPE_NOT_FOUND':
        case 'EXAMINATION_TYPE_IN_USE':
          error = i18n.t(`ERROR_MESSAGES.${action.payload.message}`)
          break
        default:
          error = errorMessage
          break
      }
      return { loading: false, error }
    case EXAMINATION_TYPE_DELETE_RESET:
      return {}
    default:
      return state
  }
}

const examinationTypeGetAllReducer = (state = {}, action: AnyAction) => {
  let error = ''
  switch (action.type) {
    case EXAMINATION_TYPE_GET_ALL_REQUEST:
      return { loading: true }
    case EXAMINATION_TYPE_GET_ALL_SUCCESS:
      return {
        loading: false,
        examinationsTypes: action.payload.examinationsTypes,
        count: action.payload.count
      }
    case EXAMINATION_TYPE_GET_ALL_FAIL:
      error = errorMessage
      return { loading: false, error }
    default:
      return state
  }
}

const examinationTypeGetOneReducer = (state = {}, action: AnyAction) => {
  let error = ''
  switch (action.type) {
    case EXAMINATION_TYPE_GET_ONE_REQUEST:
      return { loading: true }
    case EXAMINATION_TYPE_GET_ONE_SUCCESS:
      return { loading: false, examinationType: action.payload }
    case EXAMINATION_TYPE_GET_ONE_FAIL:
      switch (action.payload.message) {
        case 'EXAMINATION_TYPE_NOT_FOUND':
          error = i18n.t(`ERROR_MESSAGES.${action.payload.message}`)
          break
        default:
          error = errorMessage
          break
      }
      return { loading: false, error }
    case EXAMINATION_TYPE_GET_ONE_RESET:
      return {}
    default:
      return state
  }
}

const examinationTypeEditReducer = (state = {}, action: AnyAction) => {
  let error = ''
  switch (action.type) {
    case EXAMINATION_TYPE_EDIT_REQUEST:
      return { loading: true }
    case EXAMINATION_TYPE_EDIT_SUCCESS:
      return { loading: false, success: true }
    case EXAMINATION_TYPE_EDIT_FAIL:
      switch (action.payload.message) {
        case 'EXAMINATION_TYPE_NOT_FOUND':
          error = i18n.t(`ERROR_MESSAGES.${action.payload.message}`)
          break
        default:
          error = errorMessage
          break
      }
      return { loading: false, error }
    case EXAMINATION_TYPE_EDIT_RESET:
      return {}
    default:
      return state
  }
}

const examinationTypeExaminationSelectionSearchGetAllReducer = (state = {}, action: AnyAction) => {
  let error = ''
  switch (action.type) {
    case EXAMINATION_TYPE_EXAMINATION_SELECTION_SEARCH_GET_ALL_REQUEST:
      return { loading: true }
    case EXAMINATION_TYPE_EXAMINATION_SELECTION_SEARCH_GET_ALL_SUCCESS:
      return { loading: false, riskExposureGroups: action.payload }
    case EXAMINATION_TYPE_EXAMINATION_SELECTION_SEARCH_GET_ALL_FAIL:
      error = action.payload
      return { lodaing: false, error }
    case EXAMINATION_TYPE_EXAMINATION_SELECTION_SEARCH_GET_ALL_RESET:
      return {}
    default:
      return state
  }
}

export const examinationTypeReducers = {
  examinationTypeCreate: examinationTypeCreateReducer,
  examinationTypeGetAll: examinationTypeGetAllReducer,
  examinationTypeDelete: examinationTypeDeleteReducer,
  examinationTypeGetOne: examinationTypeGetOneReducer,
  examinationTypeEdit: examinationTypeEditReducer,
  examinationTypeExaminationSelectionSearchGetAll:
    examinationTypeExaminationSelectionSearchGetAllReducer
}
